// # components
import fileViewer from '~/components/file-viewer/file-viewer.module';
import freeDraw from '~/components/free-draw/free-draw.module';
import kdatepicker from '~/components/kdatepicker/kdatepicker.module';
import list from '~/components/list/list.module';
import main from '~/components/main/main.module';
import nodeGraphView from '~/components/node-graph-view/node-graph-view.module';
import table from '~/components/kdatatable/kdatatable.module';
import textEditor from '~/components/text-editor/text-editor.module';
import kelse from '~/components/kelse/kelse.module';
import gridstack from '~/components/gridstack/gridstack.module';
import charts from '~/components/charts/chart.module';
import codeEditor from '~/components/code-editor/code-editor.module';
import v5Frame from '~/components/v5-frame/v5-frame.module';

// # directives
import highlight from '~/scripts/directives/highlight.directive';

// # pages
import account from '~/components/account/account.module';
import adminClassDesigner from '~/components/class-designer/class-designer.module';
import chat from '~/pages/chat/chat.module';
import droit from '~/components/droit/droit.module';
import mailViewer from '~/components/mail-viewer/mail-viewer.module';
import formBuilder from '~/pages/form-builder/form-builder.module';
import home from '~/components/home/home.module';
import query from '~/components/query/query.module';
import upload from '~/components/upload/upload.module';
import workflow from '~/pages/workflow/workflow.module';
import agent from '~/pages/agent/agent.module';
import dashboard from '~/pages/dashboard/dashboard.module';
import homePage from '~/pages/home/home.module';
import batch from '~/pages/batch/batch.module';
import FastImportService from '~/components/home/fast-import/fast-import.module';
import recorder from '~/components/recorder-ui/recorder-ui.module';
import modal from './modules/modal';
import nestedUiBootstrapDropdown from './modules/nested-ui-bootstrap-dropdown.module';

// # services

export default [
	homePage,
	account,
	kdatepicker,
	list,
	main,
	highlight,
	chat,
	formBuilder,
	query,
	nodeGraphView,
	upload,
	adminClassDesigner,
	fileViewer,
	textEditor,
	freeDraw,
	table,
	modal,
	nestedUiBootstrapDropdown,
	droit,
	mailViewer,
	home,
	workflow,
	agent,
	kelse,
	gridstack,
	charts,
	dashboard,
	batch,
	codeEditor,
	v5Frame,
	FastImportService,
	recorder,
];
